import {Route, Routes, Navigate} from 'react-router-dom';
import {NewAdminRequest} from '../pages/NewAdminRequest';
import {MyAdminRequests} from '../pages/MyAdminRequests';
import {JDUBilling} from '../pages/JDUBilling';
import {BulkClassLoad} from '../pages/BulkClassLoad';
import {Home} from '../pages/Home';
import {FC} from 'react';
import {RequiredAuth} from './SecureRoute';
import {LoginCallback} from '@okta/okta-react';
import {ClassRequestFormComponent} from './ClassRequestFormComponent';
import {ScheduledClassHistory} from '../pages/ScheduledClassHistory';

const AppRoutes: FC<unknown> = () => {
    return (
        <Routes>
            <Route
                element={<RequiredAuth/>}
                path='/'
            >
                <Route
                    element={<Home/>}
                    path='/'
                />
                <Route
                    element={<NewAdminRequest/>}
                    path='newadminrequest'
                />
                <Route
                    element={<MyAdminRequests/>}
                    path='myadminrequests'
                />
                <Route
                    element={<BulkClassLoad/>}
                    path='bulkclassloadrequest'
                />
                <Route
                    element={<ClassRequestFormComponent/>}
                    path='requestclass'
                />
                <Route
                    element={<ScheduledClassHistory/>}
                    path='scheduledclasshistory'
                />
                <Route
                    element={<JDUBilling/>}
                    path='jdubilling'
                />
            </Route>
            <Route
                element={<LoginCallback/>}
                path='login/callback'
            />
            <Route
                element={<Navigate to='/'/>}
                path='*'
            />
        </Routes>
    );
};

export default AppRoutes;
